module.exports = __webpack_public_path__ + "img/65075aca9cb261f865d0b42ee8bd2785.png";